// Personal Information
export const PERSONAL_INFO = {
  name: "Wada Abera",
  title: "Software Engineering Student & Full-Stack Web Developer",
  email: "waadaaabarraa@gmail.com",
  phone: "+251993748962",
  location: "Jimma, Ethiopia",
  university: "Jimma University",
  year: "Fourth-Year",
  specialization: "Full-Stack Web Development",
  bio: "Passionate about creating innovative web solutions and exploring the frontiers of machine learning. Currently pursuing Software Engineering at Jimma University with hands-on experience in modern web technologies.",
};

// Social Media Links
export const SOCIAL_LINKS = {
  github: "https://github.com/Wadabera",
  linkedin: "https://www.linkedin.com/in/wada-abera",
  telegram: "https://t.me/promisepact",
};

// Navigation Items
export const NAV_ITEMS = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Projects", href: "#projects" },
  { name: "Skills", href: "#skills" },
  { name: "Services", href: "#services" },
  { name: "Certificates", href: "#certificates" },
  { name: "Contact", href: "#contact" },
];

// Animation Delays
export const ANIMATION_DELAYS = {
  short: 0.1,
  medium: 0.2,
  long: 0.3,
};
